import { render, staticRenderFns } from "./CDEKEditingPage.vue?vue&type=template&id=21ee7dd2&scoped=true"
import script from "./CDEKEditingPage.vue?vue&type=script&lang=js"
export * from "./CDEKEditingPage.vue?vue&type=script&lang=js"
import style0 from "./CDEKEditingPage.vue?vue&type=style&index=0&id=21ee7dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee7dd2",
  null
  
)

export default component.exports